module.exports = __webpack_public_path__ + "img/anti-corrosion.99849fa0.webp";